/* eslint-disable @typescript-eslint/no-explicit-any */
import { Input } from "@/components/ui/input";

type DocumentFormProp = {
  value: any;
  onChange: (prop: any) => void;
  onBlur: () => void;
};

export const DocumentForm = ({ value, onChange, onBlur }: DocumentFormProp) => {
  return (
    <Input
      value={value}
      type="text"
      onChange={(e: any) => onChange(e?.target?.value)}
      onBlur={onBlur}
      autoFocus={true}
    />
  );
};
